import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const User = props => {
  return (
    <SvgIcon {...props} width="73" height="73" viewBox="0 0 73 73" id="userImage">
      <circle
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        cx="35.5"
        cy="35.5"
        r="35.5"
        transform="translate(1 1)"
      />
      <rect fill="none" width="73" height="73" />
      <path
        fill="#000"
        d="M39.909,48.714a60.706,60.706,0,0,1-.132-6.183c1.072-.562,2.993-4.149,3.318-7.179.843-.069,2.172-.891,2.561-4.139a3.031,3.031,0,0,0-1.132-3.033c1.372-4.125,4.221-16.888-5.269-18.207-.977-1.715-3.478-2.583-6.728-2.583-13,.239-14.572,9.819-11.721,20.79a3.037,3.037,0,0,0-1.132,3.033c.391,3.247,1.718,4.07,2.561,4.139.323,3.028,2.32,6.616,3.4,7.179a60.721,60.721,0,0,1-.134,6.183c-1.852,4.979-11.363,5.368-16.85,10.169,5.736,5.776,15.033,9.907,24.843,9.907s21.342-7.746,23.262-9.859C51.3,54.086,41.765,53.71,39.909,48.714Z"
        transform="translate(4.052 3.464)"
      />
    </SvgIcon>
  );
};

export default User;
